
import './App.css';
import Header from "./Componentes/Header/Header";
import { Routes, Route } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import Footer from "./Componentes/Footer/Footer";
import HouseDetails1 from "./Pages/HouseDetails1";
import HouseDetails2 from "./Pages/HouseDetails2";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsOfService from "./Pages/TermsOfService";
import WhatsappFloat from "./Componentes/WhatsappFloat/WhatsappFloat";
import ScrollToTop from "./ScrollToTop";

function App() {
  return (
      <>
          <Header />
          <WhatsappFloat />
          <ScrollToTop />
          <Routes>
              <Route path="/" element={<HomePage />} />   
              <Route path="/farmstays" element={<HouseDetails1 />} />
              <Route path="/homestays" element={<HouseDetails2 />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-service" element={<TermsOfService />} />
          </Routes>
          <Footer />
      </>
  );
}

export default App;
